export enum OdataComparator {
  Contains = 0,
  Equals = 1,
  In = 2,
  LessThanOrEqualTo = 3,
  GreaterThanOrEqualTo = 4,
  Any = 5,
  NotEquals = 6,
  GreaterThan = 7,
  LessThan = 8
}
